import type { RGBA } from "./colors/colorConversion";

/**
 * Get a single pixel from image data
 */
export const getPixel = (
  data: Uint8ClampedArray,
  width: number,
  x: number,
  y: number
): RGBA => {
  const i = (y * width + x) * 4;
  return { r: data[i], g: data[i + 1], b: data[i + 2], a: data[i + 3] };
};

export const getImageDataFromCanvas = (
  canvas: HTMLCanvasElement
): ImageData => {
  const imageData = canvas
    .getContext("2d")
    ?.getImageData(0, 0, canvas.width, canvas.height);

  if (!imageData) throw new Error("Failed to get Image Data");
  return imageData;
};

export const getRgbaDataFromCanvas = (canvas: HTMLCanvasElement): RGBA[][] => {
  const imageData = getImageDataFromCanvas(canvas);

  const colorData = imageData.data;
  const rgbaData: RGBA[][] = Array.from({ length: canvas.height }, () => []);

  let row = 0;
  let col = 0;
  for (let i = 0; i < colorData.length; i += 4) {
    const r = colorData[i];
    const g = colorData[i + 1];
    const b = colorData[i + 2];
    const a = colorData[i + 3];

    const color: RGBA = { r, g, b, a };

    rgbaData[row].push(color);
    col++;
    if (col === canvas.width) {
      col = 0;
      row++;
      if (row >= canvas.height) break;
    }
  }

  return rgbaData;
};
